<template>
  <version-form :is-edit="false"></version-form>
</template>
<script>
import VersionForm from './VersionForm';

export default {
  name: 'CreateVersion',
  components: { VersionForm },
};
</script>
